export enum StoreActions {
  // Menu - Navigation
  // SelectingProduct = 'selecting_product',
  // SelectProduct = 'select_product',
  // SelectingOption = 'selecting_option',
  // SelectOption = 'select_option',

  SetIsLocalStoragePristine = 'set_is_local_storage_pristine',
  GetIsLocalStoragePristine = 'get_is_local_storage_pristine',

  // Products
  GetProducts = 'get_products',
  GetProduct = 'get_product',
  SetProducts = 'set_products',
  SetProductGroups = 'set_product_groups',
  SetProductTags = 'set_product_tags',

  // ProductSetups
  GetProductSetups = 'get_product_setups',
  GetProductSetup = 'get_product_setup',
  SetProductSetups = 'set_product_setups',

  // AcquisitionSetups
  GetAcquisitionSetups = 'get_acquisition_setups',
  GetAcquisitionSetup = 'get_acquisition_setup',
  SetAcquisitionSetups = 'set_acquisition_setups',

  // Decay
  GetDecay = 'get_decay',
  SetDecays = 'set_decays',

  // Estimates
  SelectEstimate = 'select_estimate',
  DeleteEstimate = 'delete_estimate',
  SetEstimates = 'set_estimates',
  GetEstimates = 'get_estimates',
  UpdateEstimate = 'update_estimate',
  GetSavedEstimates = 'get_saved_estimates',
  SaveEstimates = 'save_estimates',

  // Acquisitions
  SetAcquisitions = 'set_acquisitions',
  SetExcludedAcquisitions = 'set_excluded_acquisitions',

  // Vintages
  GetVintages = 'get_vintages',
  SetVintages = 'set_vintages',
  SetStartVintage = 'set_start_vintage',

  // Beta
  GetMarketRates = 'get_market_rates',
  GetBetaTimeSeries = 'get_beta_time_series',
  GetMarketRateTimeSeries = 'get_market_rate_time_series',
  GetSavedBetaRegressions = 'get_saved_beta_calibration',

  // Stable Balance
  GetUnadjustedBalances = 'get_unadjusted_balances',
  SetUnadjustedBalances = 'set_unadjusted_balances',

  // Settings
  GetGlobalSettings = 'get_global_settings',
  SetGlobalSettings = 'set_global_settings',
  GetCalibrationSettings = 'get_calibration_settings',
  SetCalibrationSettings = 'set_calibration_settings',

  // Users
  SetUsers = 'set_users',

  // Observation Dates
  SetLastObservationDate = 'set_last_observation_date',
  SetObservationDates = 'set_observation_dates'
}
